import React from 'react';
import classnames from 'classnames';
import typeName from 'type-name';

import { Tooltip, Pane, ArrayIcon, SymbolTriangleDownIcon, Text, SymbolTriangleUpIcon, ArrayStringIcon, TickIcon, SquareIcon, TextHighlightIcon, DragHandleVerticalIcon, NumericalIcon } from 'evergreen-ui'


import './object-tree.scss'



/**
 *
 */
class ObjectNode extends React.Component {

  constructor(props) {
    super(props);
    this.state = { opened: props.level > 0 };
  }

  componentWillReceiveProps(newProps) {
    if (this.props.value !== newProps.value) {
      this.setState({ opened: newProps.level > 0 });
    }
  }

  toggleNode(e) {
    this.setState({ opened: !this.state.opened });
  }

  render() {
    const { value } = this.props;
    const type = typeName(value);
    return (
      /^(number|string|boolean|null)$/.test(type) ? this.renderValue(value, type) :
        this.renderObject(value, type)
    );
  }

  renderObject(obj, type) {
    const { path, level } = this.props;
    const { opened } = this.state;
    const clevel = level > 0 ? level - 1 : 0;
    let iter = obj ? (
      type === 'Array' ?
        obj.map((v, i) => ({ prop: i, value: v })) :
        Object.keys(obj).sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        }).map((prop) => ({ prop, value: obj[prop] }))) : null


    return (
      <Pane elevation={opened ? 1 : 0}>
        <div className='object-label' onClick={this.toggleNode.bind(this)}>
          {this.renderValue(iter, type, opened)}
        </div>
        {opened && <table border="0" className="objecttree">
          <tbody>
            {iter.map(({ prop, value }) => {
              const cpath =
                type === 'Array' ? `${path}[${prop}]` :
                  path ? `${path}.${prop}` :
                    prop;
              return (
                <tr key={prop}  onMouseOver={(e)=>{
                  this.props.onHover &&  this.props.onHover(e,prop,obj)
                }}>
                  <th className='prop-name'>{type === 'Array'?value.named??'':''} {prop}</th>
                  <td className='prop-value'>
                    <ObjectNode value={value} path={cpath} level={clevel} onHover={this.props.onHover}/>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>}
      </Pane>
    );
  }


  /*  
  

*/
  renderValue(value, type, opened = false) {
    let icon = <DragHandleVerticalIcon />;
    let render = JSON.stringify(value)


    if (value && value.map) {
      const isAllStrings = value.every(item => typeof item.value === 'string');
      const strings = value.map(item => {
        if (typeof item.value === 'string') {
          return item.value;
        }
        if (item.value === null) {
          return 'null';
        }
        return typeof item.value
      })


      render = strings && strings.length > 0 ? <span style={{ color: 'grey' }}>{strings.slice(0, 3).join(',') + (strings.length > 2 ? '...' : '')}</span> : value.length;
      icon = <>
        {opened ? <SymbolTriangleDownIcon /> : <SymbolTriangleUpIcon />}
        {(isAllStrings && strings.length > 0) ? <ArrayStringIcon /> : <TypeIcon type={type} />}
      </>
    }



    switch (type) {
      case 'boolean': icon = (value ? <TickIcon /> : <SquareIcon />); break;
      case 'string': icon = (<TextHighlightIcon />); break;
      case 'number': icon = (<NumericalIcon />); break;
    }

    switch (type) {
      case 'string': render = value; break;
      case 'boolean': render = ''; break;
      case 'Arc':
        //this is dump, but for now it works
        let v = value.reduce((obj, { prop, value }) => {
          obj[prop] = value;
          return obj;
        }, {});

        render = v.isCircle ? 'Circle' : `${Math.round(v.StartAngle * 180 / Math.PI)} ${Math.round(v.EndAngle * 180 / Math.PI)}`; break;
    }

    return (
      <div className='object-node'>
        <span className={classnames('object-value', type)}>
          <Tooltip content={type}>{icon}</Tooltip><Text marginLeft={8}>{render}</Text></span>
      </div>
    );
  }


}


function TypeIcon({ type }) {
  switch (type) {
    case 'Array':
      return <ArrayIcon />;
  }
  return type
}

export function ObjectTree({ className = '', value, level = 1, style, onHover = null }) {
  return (
    <div className={classnames('object-tree', className)} style={style}>
      <ObjectNode value={value} path='' level={level} onHover={onHover} />
    </div>
  );
}

